_getScheduleMiddleWare